module.exports = __webpack_public_path__ + "img/cake-intro-x12.b9381a9a.png";